"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenCustomerChatEvent = exports.ChangeDocumentTitleEvent = exports.A11yAnnouncePageLoadEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class A11yAnnouncePageLoadEvent extends web_ui_framework_1.Event {
}
exports.A11yAnnouncePageLoadEvent = A11yAnnouncePageLoadEvent;
class ChangeDocumentTitleEvent extends web_ui_framework_1.Event {
}
exports.ChangeDocumentTitleEvent = ChangeDocumentTitleEvent;
class OpenCustomerChatEvent extends web_ui_framework_1.Event {
}
exports.OpenCustomerChatEvent = OpenCustomerChatEvent;
//# sourceMappingURL=frameEvents.js.map